import { DS_POPOVER_PLACEMENTS, type DSPopoverPlacement } from "@/src/design_system/primitives/popover/types/props";
import type { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_POPOVER_ARROW_SIDE = {
  Top: "top",
  Bottom: "bottom",
  Left: "left",
  Right: "right",
} as const;

export type DSPopoverArrowSide = ObjectValues<typeof DS_POPOVER_ARROW_SIDE>;

/** The arrow faces the activator, so it sits on the edge opposite to the placement side. */
export const DS_POPOVER_PLACEMENT_TO_ARROW_SIDE: Record<DSPopoverPlacement, DSPopoverArrowSide> = {
  [DS_POPOVER_PLACEMENTS.BottomStart]: DS_POPOVER_ARROW_SIDE.Top,
  [DS_POPOVER_PLACEMENTS.BottomEnd]: DS_POPOVER_ARROW_SIDE.Top,
  [DS_POPOVER_PLACEMENTS.TopStart]: DS_POPOVER_ARROW_SIDE.Bottom,
  [DS_POPOVER_PLACEMENTS.TopEnd]: DS_POPOVER_ARROW_SIDE.Bottom,
  [DS_POPOVER_PLACEMENTS.RightStart]: DS_POPOVER_ARROW_SIDE.Left,
  [DS_POPOVER_PLACEMENTS.RightEnd]: DS_POPOVER_ARROW_SIDE.Left,
  [DS_POPOVER_PLACEMENTS.LeftStart]: DS_POPOVER_ARROW_SIDE.Right,
  [DS_POPOVER_PLACEMENTS.LeftEnd]: DS_POPOVER_ARROW_SIDE.Right,
};
